import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { SFStack } from "../grid";
import SFTypography from "../typography";
import SFButton from "../button";
import getStyled from "../../hooks/getStyled";
import FilterGroups from "./filterGroups";

const { styled } = getStyled();

const FilterGroupsContainer = styled(SFStack)(({ theme }) => ({
  height: "100%",
  padding: theme.spacing(2.5, 0, 0, 1.25),
  backgroundColor: theme.palette.white.main,
  boxShadow: "3px 3px 9px 0px rgba(0, 0, 0, 0.08)",
  borderRadius: "0px 0px 0px 4px",
  position: "sticky",
  zIndex: 1,
}));

const FiltersGroupsHeaderContainer = styled(SFStack)(({ theme }) => ({
  height: "36px",
  padding: theme.spacing(1.6, 2.8, 1, 1),
}));

const FullSearchDialogFilters = ({
  filters,
  currentSelection,
  updateCurrentSelection,
  clearCurrentSelection,
  selectedCount,
  currentFilterModel = {},
  colNameTypes = {},
  singleGetAllValuesUrl,
  keepFiltersOpen,
  externalColNameTypes,
  externalFilterSelection,
}) => {
  const { t } = useTranslation();

  // Local state to keep track of which filter groups are expanded based on their colName
  const [expandedFilterGroups, setExpandedFilterGroups] = useState([]); // Initially all filter groups are collapsed

  const expandCollapseHandler = () => {
    if (expandedFilterGroups.length === 0) {
      setExpandedFilterGroups(filters.map((filter) => filter.colName));
    } else {
      setExpandedFilterGroups([]);
    }
  };

  const filterGroupToggleHandler = (event, isExpanded, colName) => {
    if (isExpanded) {
      setExpandedFilterGroups([...expandedFilterGroups, colName]);
    } else {
      setExpandedFilterGroups(
        expandedFilterGroups.filter((f) => f !== colName)
      );
    }
  };

  return (
    <FilterGroupsContainer>
      <FiltersGroupsHeaderContainer
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <SFTypography variant="cardNumberText">
          {`${t("components.fullSearchDialog.filters")}` +
            (selectedCount > 0 ? ` (${selectedCount})` : "")}
        </SFTypography>
        <SFStack direction="row" spacing={1.25}>
          {selectedCount > 0 && (
            <SFButton variant="text-link" onClick={clearCurrentSelection}>
              {t("components.fullSearchDialog.clearFilters")}
            </SFButton>
          )}
          <SFButton variant="text-link" onClick={expandCollapseHandler}>
            {expandedFilterGroups.length === 0
              ? t("components.fullSearchDialog.expandAll")
              : t("components.fullSearchDialog.collapseAll")}
          </SFButton>
        </SFStack>
      </FiltersGroupsHeaderContainer>
      <FilterGroups
        filters={filters}
        currentSelection={currentSelection}
        singleGetAllValuesUrl={singleGetAllValuesUrl}
        updateCurrentSelection={updateCurrentSelection}
        clearCurrentSelection={clearCurrentSelection}
        currentFilterModel={currentFilterModel}
        colNameTypes={colNameTypes}
        keepFiltersOpen={keepFiltersOpen}
        expandedFilterGroups={expandedFilterGroups}
        filterGroupToggleHandler={filterGroupToggleHandler}
        externalColNameTypes={externalColNameTypes}
        externalFilterSelection={externalFilterSelection}
      />
    </FilterGroupsContainer>
  );
};

export default FullSearchDialogFilters;
